import { useEffect, useState } from "react";
import { X, Smartphone } from "lucide-react";

type BIPEvent = Event & { prompt: () => Promise<void>; userChoice: Promise<{ outcome: string }> };
const KEY = "sdcg-install-dismissed";

/** Small "Add to home screen" banner for phone visitors. Shows once, dismissible. */
const InstallPrompt = () => {
  const [evt, setEvt] = useState<BIPEvent | null>(null);
  const [ios, setIos] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(KEY)) return;
    if (window.matchMedia("(display-mode: standalone)").matches) return;
    if (!window.matchMedia("(max-width: 768px)").matches) return;
    const onPrompt = (e: Event) => {
      e.preventDefault();
      setEvt(e as BIPEvent);
      setOpen(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    const isIos = /iphone|ipad|ipod/i.test(navigator.userAgent);
    let t: number | undefined;
    if (isIos) {
      setIos(true);
      t = window.setTimeout(() => setOpen(true), 8000);
    }
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      if (t) clearTimeout(t);
    };
  }, []);

  const dismiss = () => {
    localStorage.setItem(KEY, "1");
    setOpen(false);
  };

  if (!open) return null;
  return (
    <div role="dialog" aria-label="Add San Diego Coastal Guide to your home screen" className="fixed inset-x-3 bottom-3 z-50 rounded-2xl border border-border bg-card p-4 shadow-lg">
      <div className="flex items-start gap-3">
        <Smartphone className="mt-0.5 h-5 w-5 shrink-0 text-primary" aria-hidden />
        <div className="flex-1 font-body text-sm text-foreground">
          <p className="font-semibold">Check the coast in one tap</p>
          <p className="mt-1 text-muted-foreground">
            {ios ? "Tap the Share button, then “Add to Home Screen” for daily tides, surf and swim status." : "Add this guide to your home screen for daily tides, surf and swim status."}
          </p>
          {evt && !ios && (
            <button
              onClick={async () => {
                await evt.prompt();
                dismiss();
              }}
              className="mt-3 rounded-md bg-primary px-4 py-2 text-xs font-semibold uppercase tracking-wide text-primary-foreground"
            >
              Add to home screen
            </button>
          )}
        </div>
        <button onClick={dismiss} aria-label="Dismiss" className="rounded p-1 text-muted-foreground hover:text-foreground">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default InstallPrompt;
